import { createI18n } from 'vue-i18n';
import { messages } from './messages.js';

export const SUPPORTED_LOCALES = ['de', 'en', 'fr', 'it', 'pl', 'cs'];
export const DEFAULT_LOCALE = 'de';

export function resolveLocale(locale) {
  if (SUPPORTED_LOCALES.includes(locale)) return locale;
  return DEFAULT_LOCALE;
}

function normalizeGermanUmlautsInString(value) {
  if (typeof value !== 'string') return value;

  const PROTECTED_UE_TOKEN = '__PROTECTED_UE__';
  const protectUeInWord = (word) => word.replace(/ue/g, PROTECTED_UE_TOKEN).replace(/Ue/g, PROTECTED_UE_TOKEN);

  // Words where "ue" is correct and must not become "ü".
  const protectedText = value
    .replace(/\b[Mm]anuell[a-zA-Z]*\b/g, protectUeInWord)
    .replace(/\b[Aa]ktuell[a-zA-Z]*\b/g, protectUeInWord)
    .replace(/\b[Vv]isuell[a-zA-Z]*\b/g, protectUeInWord)
    .replace(/\b[Vv]irtuell[a-zA-Z]*\b/g, protectUeInWord)
    .replace(/\b[Ee]ventuell[a-zA-Z]*\b/g, protectUeInWord)
    .replace(/\b[Ii]ndividuell[a-zA-Z]*\b/g, protectUeInWord);

  // Heuristic conversion for legacy ASCII transliterations in German texts.
  return protectedText
    .replace(/(^|[^A-Za-z])Ae/g, '$1Ä')
    .replace(/(^|[^A-Za-z])Oe/g, '$1Ö')
    .replace(/(^|[^A-Za-z])Ue/g, '$1Ü')
    .replace(/([B-DF-HJ-NP-TV-Zb-df-hj-np-tv-z])ae/g, '$1ä')
    .replace(/([B-DF-HJ-NP-TV-Zb-df-hj-np-tv-z])oe/g, '$1ö')
    .replace(/([B-DF-HJ-NP-TV-Zb-df-hj-np-tv-z])ue/g, '$1ü')
    .replace(/Fuss/g, 'Fuß')
    .replace(/fuss/g, 'fuß')
    .replace(new RegExp(PROTECTED_UE_TOKEN, 'g'), 'ue');
}

function normalizeGermanUmlautsDeep(value) {
  if (typeof value === 'string') return normalizeGermanUmlautsInString(value);
  if (Array.isArray(value)) return value.map(normalizeGermanUmlautsDeep);
  if (value && typeof value === 'object') {
    const out = {};
    for (const [k, v] of Object.entries(value)) {
      out[k] = normalizeGermanUmlautsDeep(v);
    }
    return out;
  }
  return value;
}

const normalizedMessages = {
  ...messages,
  // Clone and normalize only DE so other locales are untouched.
  de: normalizeGermanUmlautsDeep(messages.de),
};

const initialLocale = resolveLocale(localStorage.getItem('locale'));
document.documentElement.setAttribute('lang', initialLocale);

export const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: initialLocale,
  fallbackLocale: DEFAULT_LOCALE,
  messages: normalizedMessages,
});
